module.exports = __webpack_public_path__ + "fontawesome-webfont.f7c2b4b747b1a225eb8d.eot";


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/assets/css/fonts/fontawesome/fontawesome-webfont.eot
// module id = ../../../../../src/assets/css/fonts/fontawesome/fontawesome-webfont.eot
// module chunks = 2